export default {
  configList: [],
}
